import { render, staticRenderFns } from "./liveDPlayer.vue?vue&type=template&id=21c12d4a&scoped=true"
import script from "./liveDPlayer.vue?vue&type=script&lang=js"
export * from "./liveDPlayer.vue?vue&type=script&lang=js"
import style0 from "./liveDPlayer.vue?vue&type=style&index=0&id=21c12d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c12d4a",
  null
  
)

export default component.exports